import { render, staticRenderFns } from "./voiceComposeList.vue?vue&type=template&id=f5d352d6&scoped=true&"
import script from "./voiceComposeList.vue?vue&type=script&lang=js&"
export * from "./voiceComposeList.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/voiceRec.less?vue&type=style&index=0&id=f5d352d6&lang=less&scoped=true&"
import style1 from "./voiceComposeList.vue?vue&type=style&index=1&id=f5d352d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d352d6",
  null
  
)

component.options.__file = "voiceComposeList.vue"
export default component.exports